if (!customElements.get('dm-collection-navigation')) {
  customElements.define('dm-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.dm-collection-navigation__viewport');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.viewport.scrollBy({ left: Number(button.dataset.direction) * this.viewport.clientWidth * .7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal }));
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { signal, passive: true });
      this.observer = new ResizeObserver(() => this.updateButtons());
      this.observer.observe(this.viewport);
      this.updateButtons();
      const active = this.querySelector('[aria-current="page"]');
      if (active) {
        const viewportBounds = this.viewport.getBoundingClientRect();
        const activeBounds = active.getBoundingClientRect();
        this.viewport.scrollLeft += activeBounds.left - viewportBounds.left - (viewportBounds.width - activeBounds.width) / 2;
      }
      this.updateButtons();
    }
    updateButtons() {
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.buttons.forEach(button => { button.hidden = maxScroll <= 2; });
      this.buttons[0].disabled = this.viewport.scrollLeft <= 2;
      this.buttons[1].disabled = this.viewport.scrollLeft >= maxScroll - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
